import type { ReactNode } from "react"

interface PageHeaderProps {
  title: string
  description?: ReactNode
  actions?: ReactNode
  as?: "h1"
  /** `cover`: texto blanco con sombra sutil para títulos sobre fotos. */
  variant?: "default" | "cover"
}

export function PageHeader({ title, description, actions, as: Heading = "h1", variant = "default" }: PageHeaderProps) {
  const cover = variant === "cover"
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
      <div className="min-w-0 space-y-1">
        <Heading
          className={
            "text-2xl font-semibold tracking-tight text-balance sm:text-3xl " +
            (cover ? "text-white [text-shadow:0_1px_8px_rgb(0_0_0/0.45)]" : "text-foreground")
          }
        >
          {title}
        </Heading>
        {description ? (
          <p className={"max-w-prose text-sm " + (cover ? "text-white/85" : "text-muted-foreground")}>{description}</p>
        ) : null}
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  )
}
